export enum EnumFeeDiscountCalcTypeEnum {
  ValidValue = 'enumFeeDiscountCalcType',
  Percent = '00000140-1000-0000-0000-000000000001',
  Money = '00000140-1000-0000-0000-000000000002'
}
